export default __webpack_public_path__ + "static/media/CSSCircularBackground-light-sepia-200px.8cc556aa.jpg";